import React from "react";
import styled from "styled-components";
import HeadingIcon from "../../Assets/Images/LandingPage/head_icon.svg";

// Styled h2 with your existing class
const HeadingWrapper = styled.h2.attrs(() => ({
  className: "head_wid_icon",
}))`
  position: relative;
  display: inline-block;
  margin-bottom:10px;

  &::after {
    content: "";
    position: absolute;
    right: -48px;
    top: 10px;
    transform: translateY(-50%);
    width: 51px;
    height: 51px;
    background: url(${HeadingIcon}) no-repeat center center;
    background-size: 62px;
    @media (max-width: 767px) {
      right: 0px;
    }
    @media (max-width: 500px) {
        right: -26px;
        width: 32px;
        height: 32px;
        background-size: contain;
    }
  }
`;

// Red highlight style
const Highlight = styled.span`
  color: #EE2D2F; /* same as redfont */
`;

// Component
const HeadingWithIcon = ({ children, highlight }) => {
  return (
    <HeadingWrapper>
      {children} {highlight && <Highlight>{highlight}</Highlight>}
    </HeadingWrapper>
  );
};

export default HeadingWithIcon;
